
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/[publisherSlug]/[journalSlug]/v2/submit",
      function () {
        return require("private-next-pages/partner/[publisherSlug]/[journalSlug]/v2/submit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/[publisherSlug]/[journalSlug]/v2/submit"])
      });
    }
  